import * as React from "react";
import { useNavigate } from "react-router-dom";
import { nameOfKind, pluralNameOfKind } from "../../../services/cpln";
import styles from "./style.module.scss";
import { useAppSelector } from "../../../store/hooks";
import { selectContext } from "../../../store/contextSlice";
import { Button } from "antd";
import { RenderSvgIcon } from "../../Icons/svgComponents/RenderSvgIcon";

interface Props {
  kind: string;
  canCreate: boolean;
}
export const IncorrectItem: React.FC<Props> = ({ kind, canCreate }) => {
  const { org } = useAppSelector(selectContext);
  const navigate = useNavigate();

  return (
    <div className="w-full flex flex-col items-center py-16 border rounded-lg">
      <RenderSvgIcon icon={kind as any} className={styles.svgIconDefault} />
      <div className="mt-2 mb-6 text-lg">{nameOfKind(kind)} is not found.</div>
      <div className="flex items-center">
        <Button
          onClick={() => {
            if (kind === "account") {
              navigate(`/home/account`);
              return;
            }

            navigate(`/console${`/org/${org}/${kind}`}`);
          }}
          type={"primary"}
        >
          Go to {pluralNameOfKind(kind)}
        </Button>
        {canCreate ? (
          <Button
            onClick={() => {
              navigate(`/console${`/org/${org}/${kind}/-create`}`);
            }}
            className="ml-4 action"
            type={"primary"}
          >
            Create a {nameOfKind(kind)}
          </Button>
        ) : null}
      </div>
    </div>
  );
};
